declare global {
  interface Window {
    gtag: any;
    dataLayer: any[];
    EeProductsClick: any[];
    EePromotionsClick: any[];
    eeMultiChanelVisitCartPageStep: number;
    eeMultiChanelVisitCheckoutStepShipping: number;
    eeMultiChanelVisitCheckoutStepPayment: number;
    eeMultiChanelVisitCheckoutStepPersonalData: number;
    eeMultiChanelVisitCheckoutStepInvoiceData: number;
    eeMultiChanelVisitCheckoutStepDeliveryData: number;
    eeMultiChanelVisitCheckoutStepConfirmation: number;
    eeMultiChanelFinishOrderStep: number;
    fbq?: any;
    PostAffTracker?: any;
    _hrq: any;
    trackHeurekaOrder: any;
    _customHrq?: any;
    ecotrack?: any;
    heureka?: any;
    trackHeurekaOrderNew?: any;
  }
}

export {
  fbPurchase,
  fbViewItem,
  fbAddToCart,
  fbInitiateCheckout,
} from './facebook-ads';
export {
  gaAddToCart,
  gaPurchase,
  gaViewCategory,
  gaViewItem,
  ga4ViewItem,
  ga4ViewCategory,
  ga4AddToCart,
  ga4BeginCheckout,
  ga4AddShippingInfo,
  ga4AddPaymentInfo,
  ga4Purchase,
  gaConversion,
} from './google-ads';
export {
  ga4EventsViewItem,
  ga4EventsViewItemList,
  ga4EventsViewCart,
  ga4EventsAddToCart,
  ga4EventsRemoveFromCart,
  ga4EventsBeginCheckout,
  ga4EventsAddShippingInfo,
  ga4EventsAddPaymentInfo,
  GAObject,
} from './ga4-events';
export { heurekaPurchase, heurekaPurchaseNew } from './heureka-ads';
export {
  gaViewItemObject,
  gaAddToCartObject,
  gaRemoveFromCartObject,
  gaCheckoutStepObject,
  gaViewItemImpresssionObject,
  gaPurchaseObject,
  gaTrackPromotionClick,
  gaViewItemCustom,
  gaAddToCartCustom,
  gaCheckoutStepCustom,
  gaPurchaseCustom,
  gaAdsRemarketingOtherView,
  gaTrackFbHomepageView,
  gaTrackProductClick,
  gaAdsRemarketingHomeView,
  gaTrackPromotionImpressions,
  gaAdsRemarketingSearchView,
  gaAdsRemarketingPurchaseView,
  gaAdsRemarketingCategoryView,
  gaAdsRemarketingProductView,
  gaViewProductGeneralObject,
  gaAdsRemarketingCartView,
} from './google-ads-send-object';

export {
  ga4EventsUniversalPush,
  ga4EventsItem,
  ga4EventsItemDetail,
  ga4CartEvent,
  ga4EventsPurchase,
  ga4EventsRefund,
  ga4EventsPromotion,
} from './ga4-events-push';

export { ecomailPurchase, ecoTrackCart } from './ecomail';

export { dognetPurchase } from './dognet';
